<template>
<div>
  <Modal v-model="visible" width="1300px" title="保单明细" :footer-hide="true" :mask-closable="false" class="my-modal">
    <br />
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="receiptRevisitStatus">
          <div>{{ RECEIPT_STATUS[row.receiptStatus] }}/{{ VERIFY_STATUS[row.verifyStatus] }}</div>
        </template>
        <template slot-scope="{ row }" slot="userName"> <span :class="row.workingState == 1 ? 'opening' : 'close'"></span>{{ row.userName }} </template>
        <template slot-scope="{ row }" slot="rateMode">
          <span>{{ row.rateMode == 1 ? '年度' : '月度' }}</span>
          <template v-if="row.calculateIndex == 1">R13</template>
          <template v-else-if="row.calculateIndex == 2">R25 </template>
          <template v-else-if="row.calculateIndex == 3">R37</template>
          <template v-else>R49</template>
        </template>
        <!-- 风险单类型 -->
        <template slot-scope="{ row }" slot="isRiskPolicy">
          <span class="my-tag red" v-if="row.isRiskPolicy == 1">是</span>
          <span class="my-tag green" v-else>否</span>
        </template>
        <template slot-scope="{ row }" slot="action2">
          <span class="table-btn" @click="unmarkRiskPolicy(row)" v-if="row.isRiskPolicy == 1">取消标记</span>
          <span class="table-btn red" @click="markRiskPolicy(row)" v-else>标记为风险单</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="openDetail(row)">明细</span>
        </template>
      </Table>
      <Page v-if="showPage" :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
  </Modal>
  <!-- 确认弹窗 -->
  <confirm-modal ref="confirmModal"></confirm-modal>
</div>
  
</template>

<script>
import { pageTool } from '@/api/mixins';
import confirmModal from '@/components/commons/confirmModal';
export default {
  mixins: [pageTool],
  components: { confirmModal },
  data() {
    return {
      columns: [],
      searchParams: {},
      visible: false,
      loading: false,
      showUser: true,
      detailCode: '',
      showPage: false
    };
  },
  created() {},
  methods: {
    // 取消风险单标记
    unmarkRiskPolicy(item) {
      if (!this.$units.pointAction('offline_81_8_btn7')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      item.id = item.riskPolicyId;
      this.$http({
        url: '/buz/userCashWithdrawLog/unmarkRiskPolicy',
        type: 'POST',
        data: item
      }).then(res => {
        this.$notice.success('取消成功!');
        this.getList();
      });
    },
    // 标记风险单
    markRiskPolicy(item) {
      if (!this.$units.pointAction('offline_81_8_btn7')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '您是否要将选择的保单标记为风险单？'
        })
        .then(() => {
          item.reportId = item.settlementReportId;
          this.$http({
            url: '/buz/userCashWithdrawLog/markRiskPolicy',
            type: 'POST',
            data: item
          }).then(res => {
            this.$notice.success('标记成功!');
            this.getList();
          });
        });
    },
    listCallback(res) {
      this.showPage = res.pages !== 0;
    },
    openDetail(row) {
      console.log('row--', row, this.searchParams);
      this.$emit('openDetail', {
        ...row,
        detailId: this.searchParams.detailId,
        salaryDetailId: this.searchParams.salaryDetailId,
        detailIds: this.searchParams.detailIds,
        salaryDetailIds: this.searchParams.salaryDetailIds,
        detailCode: this.detailCode
      });
    },
    open({ columns, params, detailCode }) {
      if (params.userId) {
        this.showUser = false;
      }
      this.searchParams = {};
      this.visible = true;
      this.columns = columns;
      this.detailCode = detailCode;
      this.searchParams = {
        ...this.searchParams,
        ...params
      };
      this.initListAjax('/buz/userSalaryDetails/baseMethod/queryDetail');
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  .btn-add {
    cursor: pointer;
    color: #236dff;
    margin-left: 10px;
  }

  /deep/ {
    .ivu-checkbox-inner {
      top: -1px;
    }

    .ivu-checkbox-group-item {
      width: 25%;
      margin-right: 0;
    }
  }
}

.tab-box {
  position: relative;
  margin-bottom: 10px;

  .tab-name {
    position: absolute;
    left: 0;
    top: 11px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/ {
    .ivu-tabs-nav {
      padding-left: 120px;
    }
  }
}
</style>
